import {noop} from '@github-ui/noop'
import {useMemo} from 'react'

import type {MarkerNavigationImplementation} from '../lib/commit-conversations/types'

export const OVERLAY_PORTAL_CONTAINER_NAME = 'commit-details-marker-portal'

export function useDiffInlineMarkerNav(): MarkerNavigationImplementation {
  return useMemo(
    () => ({
      filteredMarkers: [],
      activeGlobalMarkerID: '',
      decrementActiveMarker: noop,
      incrementActiveMarker: noop,
      overlayPortalContainerName: OVERLAY_PORTAL_CONTAINER_NAME,
    }),
    [],
  )
}
